
const BASE_API_URL = _env.REACT_APP_API_URL;

/* ----------------------------------------------------------------------------------- */
/* ------------------------------------   APIs  -------------------------------------- */
/* ----------------------------------------------------------------------------------- */
export const API_UPLOAD_PLAN = `${BASE_API_URL}/uploadplan`;
export const API_EXPORT_PLAN_TO_IMAGE = `${BASE_API_URL}/exportPlanToImage`;